import {
  CheckboxField,
  ComboboxField,
  DateField,
  DropdownField,
  ImageField,
  LinkField,
  NumberField,
  SerialNumberField,
  TextareaField,
  TextField,
  TimeField,
} from "./fields";
import { FC } from "react";
import { ImageObject } from "../../../hooks/database/types/inventories";

export type Field = {
  key: string;
  label?: string;
  required?: boolean;
  error?: { message: string };
  sortKey?: string;
} & (
  | {
      type: "text" | "textarea" | "time" | "date" | "link" | "löpnummer";
      value: string | null | undefined;
    }
  | {
      type: "dropdown" | "combobox";
      value: string | null | undefined;
      options: string | string[];
    }
  | { type: "number"; value: number | null | undefined }
  | {
      type: "image";
      value: ImageObject[] | null | undefined;
    }
  | { type: "checkbox"; value: boolean | null | undefined }
);

const FieldHandler: FC<{
  field: Field;
  onChange: (key: string, value: Field["value"]) => void;
  onBlur?: (field: Field) => void;
}> = ({ field, onChange, onBlur }) => {
  switch (field.type) {
    case "text":
      return <TextField onChange={onChange} onBlur={onBlur} field={field as Field & { type: "text" }} />;
    case "number":
      return <NumberField onChange={onChange} onBlur={onBlur} field={field as Field & { type: "number" }} />;
    case "dropdown":
      return <DropdownField onChange={onChange} field={field as Field & { type: "dropdown" }} />;
    case "image":
      return <ImageField onChange={onChange} field={field} />;
    case "time":
      return <TimeField onChange={onChange} field={field as Field & { type: "time" }} />;
    case "date":
      return <DateField onChange={onChange} field={field as Field & { type: "date" }} />;
    case "textarea":
      return <TextareaField onChange={onChange} onBlur={onBlur} field={field as Field & { type: "textarea" }} />;
    case "checkbox":
      return <CheckboxField onChange={onChange} field={field as Field & { type: "checkbox" }} />;
    case "link":
      return <LinkField onChange={onChange} field={field as Field & { type: "link" }} />;
    case "combobox":
      return <ComboboxField onChange={onChange} field={field as Field & { type: "combobox" }} />;
    case "löpnummer":
      return <SerialNumberField onChange={onChange} field={field as Field & { type: "löpnummer" }} />;
    default:
      return <span>"{(field as any).type}" is not a supported field type</span>;
  }
};

export default FieldHandler;
